// LOADER ************************************************************************************
/*********************************************************************************************
 * Add a loading state to the specified button.
 *
 * @param {HTMLElement} elem - The element to which the 'lf-loading' class will be added.
 */
// const lfLoadThis = (elem) => elem.classList.add("lf-loading");

// DROPDOWN **********************************************************************************
/*********************************************************************************************
 * Handle dropdown behavior.
 *
 */
const handleDropdown = () => {
	const dropWrappers = document.querySelectorAll('[data-drop="dropdown"]');

	dropWrappers.forEach((item) => {
		item.addEventListener("click", function () {
			dropWrappers.forEach((el) => {
				if (el !== this) {
					if (el.id === "lf-pf-selling-plan-group") {
					} else {
						el.classList.remove("active");
						if (el.nextElementSibling) el.nextElementSibling.style.maxHeight = "0";
					}
				}
			});

			this.classList.toggle("active");
			const content = this.nextElementSibling;

			if (content) {
				content.style.maxHeight = this.classList.contains("active") ? `${content.scrollHeight}px` : "0";
			}
		});
	});
};

// SEARCH ************************************************************************************
/*********************************************************************************************
* Show the search bar and related UI changes.
	*
	* @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
*/
const showSearch = () => {
    const elements = {
        search: document.querySelector('[data-search-container]'),
        html: document.documentElement,
        searchInput: document.getElementById('Search')
    };

    if (Object.values(elements).some(el => !el)) return;

    const { search, html, searchInput } = elements;

    html.classList.add('stop-scrolling');
    search.classList.add('lf-open');
    // showBgFilter();

    setTimeout(() => searchInput.focus(), 1000);

    document.getElementById('predictive-search')?.addEventListener("touchstart", () => {
        setTimeout(() => searchInput.blur(), 500);
    });
}

/*********************************************************************************************
* Hide the search bar and revert UI changes.
	*
	* @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
*/
const hideSearch = (keepFilterActive = false) => {
    const elements = {
        search: document.querySelector('[data-search-container]'),
        html: document.documentElement,
        searchInput: document.getElementById('Search')
    };

    if (Object.values(elements).some(el => !el)) return;

    const { search, html, searchInput } = elements;

    html.classList.remove('stop-scrolling');
    search.classList.remove('lf-open');
    if (!keepFilterActive) hideBgFilter();

    searchInput.value = '';
    searchInput.dispatchEvent(new Event('input'));
}

/*********************************************************************************************
 * Show background filter.
 *
 */
const showBgFilter = (zIndex) => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	filter.classList.add("active");
	if (zIndex) filter.style.zIndex = zIndex;
};

/**
 * Hide background filter.
 *
 */
const hideBgFilter = () => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	setTimeout(() => filter.style.removeProperty("z-index"), 700);
	filter.classList.remove("active");
};

/*********************************************************************************************
 * Set the document height CSS variable to the current window height.
 */
const documentHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

document.addEventListener("DOMContentLoaded", () => {
	handleDropdown();
	documentHeight();
});
